const R_INVALID_CHARACTERS = /[^\d\.-]/;
export default function tryParseNumber(value) {
    if (typeof value === "number") {
        return value;
    }
    // check that the number has expected characters first as Number(value) parses a few
    // oddities we don't want (e.g, "Infinity", scientific notation, blank space = 0)
    if (value == null || value === "" || R_INVALID_CHARACTERS.test(value)) {
        return null;
    }
    const number = Number(value);
    return Number.isNaN(number) ? null : number;
}



// WEBPACK FOOTER //
// ./src/assets/scripts/utils/tryParseNumber.ts